export default "__VITE_ASSET__9db3cf81__"